var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanceFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 10.5,
    width: 37,
    height: 29,
    rx: 2.5,
    fill: "#ECF8F8",
    stroke: "#73737B",
    strokeLinecap: "square",
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanceFloor);
export default __webpack_public_path__ + "static/media/dance-floor.703372f2.svg";
export { ForwardRef as ReactComponent };